<template>
  <div>
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <ActionButton
        class="m-1"
        text="Añadir Solicitud"
        variant="success"
        i="fas fa-file-plus"
        @click="goToAddRequest()"
      />
    </page-header>

    <filter-manager
      v-model="this.filterModel"
      :filters="filtersHeader"
      :open-advanced="openAdvanced"
      @search="onSearch"
      @fiscalYear="
        updateFiltersData('fiscalYear', $event, 'onFiscalYearChanged')
      "
      @regionId="updateFiltersData('regionId', $event, 'onRegionChanged')"
      @municipalityId="
        updateFiltersData('municipalityId', $event, 'onMunicipalityChanged')
      "
    />
    <separator
      class="my-3"
      text="Resultado de Solicitudes de Materiales y Equipos"
    />

    <custom-result-not-found v-if="result.data.length === 0" />

    <search-result
      :result-data="result"
      @do-search="getMaterialsData"
      @on-page-change="onPageChangeHandler"
    />
  </div>
</template>
<script>
import FilterManager from 'FilterManager';
import PageHeader from 'PageHeader';
import alert from '@/mixin/alert.mixin';
import CustomResultNotFound from 'custom-result-not-found';
import Separator from 'custom-separator';
import SearchResult from './components/SearchResult';
import { getSearchResult } from '@/modules/materials-equipment/api.js';
import locationService from '@/services/api/location.api.js';
import academicService from '@/services/api/academicUtils.api.js';
import materialsService from '@/services/api/materialsEquipment.api.js';
import ActionButton from 'ActionButton';
import storeMixin from '@/mixin/storeGenerator';

const initialFilterModel = () => ({
  fiscalYear: null,
  statusId: null,
  requestNumber: null,
  classroomType: null,
  locationSchool: null,
  regionId: null,
  schoolId: null,
  municipalityId: null,
});

const initialResultModel = () => ({
  data: [],
  pagination: {},
});

export default {
  name: 'MainMaterialsEquipmentRequest',
  components: {
    PageHeader,
    CustomResultNotFound,
    Separator,
    FilterManager,
    SearchResult,
    ActionButton,
  },
  mixins: [storeMixin, alert],
  data: () => ({
    page: {
      icon: 'fas fa-user-edit',
      title: 'Manejo de Solicitud de Materiales y Equipos',
      routes: ['Inicio', 'PEI', 'Manejo de Solicitud de Materiales y Equipos'],
    },
    collections: {
      fiscalYears: [],
      status: [],
      regions: [],
      saloonTypes: [],
      municipalities: [],
      schools: [],
    },
    filterModel: {
      fiscalYear: null,
      statusId: null,
      requestNumber: null,
      classroomType: null,
      locationSchool: null,
      regionId: null,
      schoolId: null,
      municipalityId: null,
    },
    result: {
      data: [],
      pagination: {},
    },
    regionDisabled: false,
    municipalityDisabled: false,
    schoolDisabled: false,
    openAdvanced: false,
  }),
  computed: {
    filtersHeader() {
      return [
        {
          name: 'fiscalYear',
          component: 'CustomDropDown',
          options: this.collections.fiscalYears,
          value: this.filterModel.year,
          placeholder: 'Seleccione el año',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: false,
          class: 'col-md-4',
          classContainer: 'w-100',
          validations: 'required',
        },
        {
          name: 'statusId',
          component: 'CustomDropDown',
          options: this.collections.status,
          value: this.filterModel.statusId,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4',
          classContainer: 'w-100',
        },
        {
          name: 'requestNumber',
          component: 'CustomInput',
          placeholder: 'Escriba número de solicitud',
          value: this.filterModel.requestNumber,
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-md-4',
          type: 'text',
        },
        {
          name: 'classroomType',
          label: 'Tipo de Salón',
          component: 'CustomDropDown',
          options: this.collections.saloonTypes,
          value: this.filterModel.classroomType,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          classContainer: 'w-100',
          isAdvanced: true,
        },
        {
          name: 'regionId',
          component: 'CustomDropDown',
          options: this.collections.regions,
          value: this.filterModel.region,
          label: 'Región',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          classContainer: 'w-100',
          isAdvanced: true,
        },
        {
          name: 'municipalityId',
          component: 'CustomDropDown',
          options: this.collections.municipalities,
          value: this.filterModel.municipality,
          label: 'Municipio',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          classContainer: 'w-100',
          isAdvanced: true,
        },
        {
          name: 'locationSchool',
          component: 'CustomDropDown',
          options: this.collections.schools,
          value: this.filterModel.school,
          label: 'Escuela',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-3',
          classContainer: 'w-100',
          isAdvanced: true,
        },
      ];
    },
  },
  async mounted() {
    this.fetchStatus();
    this.fetchFiscalYears();
    this.fetchSaloonTypes();

    this.openAdvanced = this.filtersHeader.some(
      (filter) => filter.value != null && filter.isAdvanced
    );
  },
  methods: {
    updateFiltersData(key, event, callback) {
      if (event != undefined && event != null && event != '') {
        this.filterModel[key] = event;
      } else {
        this.filterModel[key] = null;
      }

      if (callback != undefined) {
        if (typeof this[callback] == 'function') {
          this[callback](event);
        }
      }
    },
    goToAddRequest() {
      const self = this;

      self.$router.push({
        name: 'materialAddRequest',
        params: {
          /*commentDate: new Date(),
          codeViewTypeId: codeViewTypes.AnadirComentario,*/
        },
      });
    },
    async loadFsicalYears() {
      const response = await materialsService.getFiscalYears();
      this.collections.fiscalYears = response.data;
      this.filterModel.fiscalYear = response.data[0];

      await this.fetchRegions(response.data[0]);
    },
    async fetchStatus() {
      const response = await academicService.getStatusList();
      this.collections.status = response.data;
    },
    async fetchRegions(fiscalYear) {
      const { data } = await locationService.getRegions({
        AcademicYearId: fiscalYear.id,
      });

      this.collections.regions = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filterModel.region = data[0];
        this.municipalityDisabled = true;
      } else {
        this.municipalityDisabled = false;
      }
    },
    async fetchSaloonTypes() {
      const { data } = await academicService.getSaloonType();
      this.collections.saloonTypes = data;
    },
    async fetchMunicipalities(region) {
      const { data } = await locationService.getMunicipalities({
        RegionId: region.id,
        AcademicYearId: this.filterModel.fiscalYear.id,
      });

      this.collections.municipalities = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filterModel.municipality = data[0];
        this.municipalityDisabled = true;
      } else {
        this.municipalityDisabled = false;
      }
    },
    async fetchSchools(municipality) {
      const { data } = await locationService.getSchools({
        academicYearId: this.filterModel.fiscalYear.id,
        municipalityId: municipality.id,
      });

      this.collections.schools = data;

      if (data != null && data.length == 1 && data[0].selected) {
        this.filterModel.school = data[0];
        this.schoolDisabled = true;
      } else {
        this.schoolDisabled = false;
      }
    },
    async fetchFiscalYears() {
      const response = await academicService.getFiscalYears();
      this.collections.fiscalYears = response.data;
      if (response.data != null) {
        this.filterModel.fiscalYear = response.data[0];
        this.filterModel.fiscalYear = response.data[0];
        await this.fetchRegions(response.data[0]);
      }
    },
    async onFiscalYearChanged(fiscalYear) {
      this.filterModel.school = null;
      this.filterModel.region = null;
      this.filterModel.municipality = null;

      this.collections.municipalities = [];
      this.collections.schools = [];
      this.collections.regions = [];

      await this.fetchRegions(fiscalYear);
    },
    async onRegionChanged(region) {
      this.filterModel.municipality = null;
      this.filterModel.school = null;

      this.collections.municipalities = [];
      this.collections.schools = [];

      await this.fetchMunicipalities(region);
    },
    async onMunicipalityChanged(municipality) {
      this.filterModel.school = null;
      this.collections.schools = [];

      await this.fetchSchools(municipality);
    },
    onSearch(filters, pageIndex = 1) {
      if (filters) this.filterModel = filters;

      this.getMaterialsData(pageIndex);
    },
    async getMaterialsData(pageIndex = 1) {
      let filterModel = this.filterModel;
      let payload = {
        fiscalYear: filterModel.fiscalYear?.id ?? null,
        statusId: filterModel.statusId?.id ?? null,
        requestNumber: filterModel.requestNumber,
        classroomType: filterModel.classroomType?.id ?? null,
        locationSchool: filterModel.locationSchool?.id ?? null,
        pageIndex: pageIndex,
        pageSize: 20,
      };
      let { data: response } = await getSearchResult(payload);
      this.result = {
        data: response.data,
        pagination: {
          currentPage: response.currentPage,
          totalItemCount: response.totalItemCount,
          pageCount: response.pageCount,
          count: response.count,
          perPage: 20,
        },
      };
    },
    onPageChangeHandler(page) {
      this.getMaterialsData(page);
    },
  },

  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = ['materialAddRequest'];

    next((vm) => {
      if (persistRoutes.some((x) => x == from.name)) {
        vm.recoveryData();
        vm.onSearch(vm.filterModel, vm.result.pagination.currentPage);
      } else {
        vm.shouldRecovery = false;
        vm.openAdvanced = false;

        vm.filterModel = initialFilterModel();
        vm.result = initialResultModel();

        vm.onSearch();
      }
    });
  },
};
</script>
<style scoped></style>
